import { Dashboard } from '../../models/Dashboard'
import Button from '../app/design/Button'
import Heading from '../app/design/Heading'
import Paragraph from '../app/design/Paragraph'

type Props = {
    dashboard?: Dashboard
    searchtext: string
    actionButton?: React.ReactNode
}

export function EmptyDashboardLayout({ dashboard, searchtext, actionButton }: Props) {
    if (!dashboard) {
        return null
    }
    return (
        <div className="flex w-full flex-col items-center justify-center gap-4 py-5">
            <img
                src={
                    Boolean(searchtext)
                        ? '/icons/bug-fixing-1.svg'
                        : '/icons/empty-dashboard-checklist.svg'
                }
                alt={dashboard.title}
                className="mx-auto w-[100px]"
            />
            <div className="flex flex-col items-center justify-center gap-2">
                <Heading size="xs">{Boolean(searchtext) ? 'No results' : dashboard.title}</Heading>
                <Paragraph size="sm" className="text-gray-600">
                    {Boolean(searchtext)
                        ? 'Try again with a different search term'
                        : 'Nothing here yet!'}
                </Paragraph>
            </div>

            {actionButton}

            {!Boolean(actionButton) && !Boolean(searchtext) && dashboard.buttonLinkUrl && (
                <Button
                    size="small"
                    intent="secondary"
                    leftIcon={'plus.small'}
                    href={dashboard.buttonLinkUrl}
                >
                    {dashboard.buttonString}
                </Button>
            )}
        </div>
    )
}
